/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProviderComponentUsageInfo } from './providerComponentUsageInfo';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';


export interface ProviderComponentUsageDetails { 
    /**
     * Component Id
     */
    component_id?: string;
    /**
     * Org Id
     */
    org_id?: string;
    vcds_service_type?: VcdsServiceTypeEnum;
    /**
     * Report time for component usage
     */
    report_time?: Date;
    usage?: ProviderComponentUsageInfo;
}
export namespace ProviderComponentUsageDetails {
}


